// extracted by mini-css-extract-plugin
module.exports = {"component":"StepBar_component__npQ6r","item":"StepBar_item__H_I1o","step":"StepBar_step__yhdaP","icon":"StepBar_icon__4E1AJ","active":"StepBar_active__UwY8l"};